// Estilos compartidos para proteger el HTML crudo (dangerouslySetInnerHTML)
// que llega del backend en Context.tsx y Summary.tsx contra el CSS de tag
// del periódico que aloja el widget (sin estas reglas, un simple `p { ... }`
// del host gana porque las etiquetas crudas no tienen ninguna clase de MUI).
const richTextContentStyles = {
  '& p, & ul, & ol, & li, & h1, & h2, & h3, & h4, & h5, & h6, & blockquote, & strong, & b, & em, & i':
  {
    fontFamily: 'inherit !important',
    fontSize: 'inherit !important',
    lineHeight: 'inherit !important',
    letterSpacing: 'inherit !important',
    color: 'inherit !important',
  },
  '& p, & ul, & ol, & blockquote, & h1, & h2, & h3, & h4, & h5, & h6': {
    margin: '0 0 1em 0 !important',
  },
  '& ul, & ol': {
    paddingInlineStart: '1.25em !important',
  },
  '& strong, & b': {
    fontWeight: '700 !important',
  },
  '& em, & i': {
    fontStyle: 'italic !important',
  },
  '& a': {
    color: 'inherit !important',
    textDecorationColor: 'currentColor !important',
    fontWeight: '500 !important',
  },
  '& li': {
    listStyleType: 'disc !important',
  },
}

export default richTextContentStyles
